var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable, toJS } from 'mobx';
import { SingleConcurrentRequestController } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import { safeReaction } from '../util/MobxUtil';
export default class TranslationsStore {
    constructor(rootStore, translations) {
        Object.defineProperty(this, "translations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "translationsPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "provided", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environmentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "translate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (key, group = 'global', param) => {
                const label = `${group}:${key}`;
                if (this.translations && this.translations[group] && this.translations[group][key]) {
                    const value = this.translations[group][key];
                    if (param) {
                        return this.parseTextParams(value, param);
                    }
                    return value;
                }
                this.logErrorIfNeeded(label);
                return label;
            }
        });
        Object.defineProperty(this, "logErrorIfNeeded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (label) => {
                if (Object.keys(this.translations || {}).length) {
                    const error = new Error('Translation missing');
                    error.stack = `label: ${label} , page: ${window.location.pathname}`;
                    ErrorUtil.pushErrorToTeliaRum(error);
                    if (typeof process !== 'undefined' && process.env.JEST_WORKER_ID === undefined) {
                        console.error(error);
                    }
                }
            }
        });
        Object.defineProperty(this, "parseTextParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (textValue, paramObject) => {
                return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
            }
        });
        Object.defineProperty(this, "fetchJson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url) => {
                try {
                    return await this.controller.get(url);
                }
                catch (_error) {
                }
                return null;
            }
        });
        Object.defineProperty(this, "updateTranslations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (this.provided) {
                    return;
                }
                const url = this.environmentStore.URLData.getTranslationsURL();
                const response = await this.fetchJson(url);
                if (response === null || response === void 0 ? void 0 : response.translations) {
                    this.setTranslations(false, response.translations);
                }
            }
        });
        makeObservable(this);
        this.environmentStore = rootStore.environmentStore;
        if (translations) {
            this.setTranslations(true, translations);
        }
        else if (!rootStore.propStateStore.isSsr) {
            this.translationsPromise = this.updateTranslations();
            safeReaction(rootStore, () => this.environmentStore.lang, () => this.updateTranslations());
        }
    }
    setTranslations(provided, translations) {
        this.provided = provided;
        this.translations = toJS(translations);
    }
}
__decorate([
    observable.struct
], TranslationsStore.prototype, "translations", void 0);
__decorate([
    action
], TranslationsStore.prototype, "setTranslations", null);
//# sourceMappingURL=TranslationsStore.js.map